import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { SettingsTemplateList } from './settings-template-list.component';

@NgModule({
  imports: [SharedModule],
  declarations: [SettingsTemplateList],
  exports: [SettingsTemplateList],
})
export class SettingsTemplateListModule { }
